module.exports = __webpack_public_path__ + "static/media/corporate-services-img42.aecf9131.jpg";